import { api } from "./api";

//TAX SETTINGS
export const colorCreateApi = (data) => {
  return api.post(`/configuration/interface/update`, JSON.stringify(data));
};
export const colorViewApi = (params) => {
  return api.get(`/configuration/interface/view`, JSON.stringify(params));
};
